module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n9n7n4r-4f758b10d2e31dff59e2f3b0c1c8e79c.svg";